import React from 'react';
import GiftcardBookEvent from '../../pages/public/js/GiftcardBookEvent';
import GiftcardRenewal from '../../pages/public/js/GiftcardRenewal';
import GiftcardRenewalSuccess from '../../pages/public/js/GiftcardRenewalSuccess';
import GiftcardRenewalError from '../../pages/public/js/GiftcardRenewalError';
import RedirectToExternal from '../RedirectToExternal';
import { Routes, Route } from 'react-router-dom';

const GiftcardRoutes = () => (
  <Routes>
    <Route path="/book-event" element={<GiftcardBookEvent />} />
    <Route path="/renewal" element={<GiftcardRenewal />} />
    <Route path="/renewal/success" element={<GiftcardRenewalSuccess />} />
    <Route path="/renewal/error" element={<GiftcardRenewalError />} />
    {/* Catch-all route for undefined paths */}
    <Route path="*" element={<RedirectToExternal url={`${process.env.REACT_APP_WEBSITE_BASE_URL}`} />} />
  </Routes>
);

export default GiftcardRoutes;
